import { NavLink, Outlet } from 'react-router-dom';
import { clsx } from 'clsx';

interface TabDefinition {
  to: string;
  label: string;
}

const tabs: TabDefinition[] = [
  { to: 'candidates', label: 'Candidates' },
];

export const OnboardingLayout = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold leading-7 text-rgf-gray-900 sm:text-3xl">
          Onboarding
        </h1>
        <p className="mt-1 text-sm text-rgf-gray-500">
          Digitized pre-onboarding and onboarding workflow for Changemakers and Block Changemakers.
        </p>
      </div>

      <div className="border-b border-rgf-gray-200">
        <nav className="-mb-px flex space-x-6" aria-label="Onboarding tabs">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                clsx(
                  'whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium transition-colors',
                  isActive
                    ? 'border-rgf-primary-500 text-rgf-primary-700'
                    : 'border-transparent text-rgf-gray-500 hover:border-rgf-gray-300 hover:text-rgf-gray-700',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
};
